import { render, staticRenderFns } from "./BackgroundComponent.vue?vue&type=template&id=4097faed&scoped=true"
import script from "./BackgroundComponent.vue?vue&type=script&lang=js"
export * from "./BackgroundComponent.vue?vue&type=script&lang=js"
import style0 from "./BackgroundComponent.vue?vue&type=style&index=0&id=4097faed&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4097faed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4097faed')) {
      api.createRecord('4097faed', component.options)
    } else {
      api.reload('4097faed', component.options)
    }
    module.hot.accept("./BackgroundComponent.vue?vue&type=template&id=4097faed&scoped=true", function () {
      api.rerender('4097faed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/BackgroundComponent.vue"
export default component.exports